<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li
        v-for="(breadcrumb, index) in breadcrumbs"
        :key="index"
        class="breadcrumb-item"
        :class="{ active: index === breadcrumbs.length - 1 }"
      >
        <router-link
          v-if="breadcrumb.to && breadcrumb.to != null"
          :to="breadcrumb.to"
          >{{ breadcrumb.text }}</router-link
        >
        <span v-else>{{ breadcrumb.text }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    breadcrumbName: String,
    breadcrumbParentName: String,
    breadcrumbParentLink: String,
    traningName: String,
    traningCategoryName: String,
    traningCategoryLink: Number,
    trainingNameEdit: String,
    editName: String,
    viewTrainingRequest: Boolean,
    showEventTab: Boolean,
  },
  computed: {
    breadcrumbs() {
      const breadcrumbs = [];
      let route = this.$route;

      //console.log(this.trainingNameEdit);
      // Traverse through the matched routes to gather breadcrumb data
      // console.log(route.matched);
      route.matched.forEach((match) => {
        if (
          match.path == "/training-event-category-list:pathMatch(.*)*" &&
          this.$rights.includes("VIEW_TRAINING_EVENT")
        ) {
          breadcrumbs.push({
            text: this.$t("trainingevents"),
            to: "/training-events",
          });
        }

        if (
          match.path == "/category-details:pathMatch(.*)*" &&
          this.showEventTab
        ) {
          breadcrumbs.push({
            text: this.$t("trainingevents"),
            to: "/training-events",
          });
        }

        if (match.path == "/category-details:pathMatch(.*)*") {
          breadcrumbs.push({
            text: this.$t("training_event_categorys"),
            to: "/training-event-category-list",
          });
        }
        if (match.path == "/edit-user") {
          breadcrumbs.push({
            text: this.$t("user management"),
            to: "/users",
          });
        }
        // if (match.path == "/subscribe-module") {
        //   breadcrumbs.push({
        //     text: this.$t("Newsletter Subscription"),
        //     to: "/subscribe-module",
        //   });
        // }
        if (match.path == "/create-user" || match.path == "/manage-newsletter" || match.path == "/manage-newsletter:pathMatch(.*)*" || match.path == "/create-news-letter" || match.path == "/edit-news-letter:pathMatch(.*)*" || match.path == "/preview-news-letter" || match.path == "/preview-news-letter:pathMatch(.*)*") {
          breadcrumbs.push({
            text: this.$t("user management"),
            to: "/users",
          });
        }
        if (match.path == "/inactive-events:pathMatch(.*)*") {
          breadcrumbs.push({
            text: this.$t("trainingevents"),
            to: "/training-events",
          });
        }

        if (match.path == "/create-training-event") {
          breadcrumbs.push({
            text: this.$t("trainingevents"),
            to: "/training-events",
          });
        }
        if (match.path == "/edit-training-event") {
          breadcrumbs.push({
            text: this.$t("trainingevents"),
            to: "/training-events",
          });
        }

        if (match.path == "/training-event-category:pathMatch(.*)*") {
          breadcrumbs.push({
            text: this.$t("trainingevents"),
            to: "/training-events",
          });
        }

        if (match.path == "/training-event-category:pathMatch(.*)*") {
          breadcrumbs.push({
            text: this.$t("training_event_categorys"),
            to: "/training-event-category-list",
          });
        }
        if (match.path == "/create-tenant") {
          breadcrumbs.push({
            text: this.$t("tenants"),
            to: "/tenants",
          });
        }
        if (match.path == "/edit-tenant") {
          breadcrumbs.push({
            text: this.$t("tenants"),
            to: "/tenants",
          });
        }
        if (match.path == "/save_video") {
          breadcrumbs.push({
            text: this.$t("videos"),
            to: "/uploadvideo",
          });
        }
        if (match.path == "/edit_video:pathMatch(.*)*") {
          breadcrumbs.push({
            text: this.$t("videos"),
            to: "/uploadvideo",
          });
        }
        if (match.path == "/enter_category_name") {
          breadcrumbs.push({
            text: this.$t("videos"),
            to: "/uploadvideo",
          });
        }

        if (match.path == "/edit-category-name:pathMatch(.*)*") {
          breadcrumbs.push({
            text: this.$t("videos"),
            to: "/uploadvideo",
          });
        }

        if (match.path == "/create-venue") {
          breadcrumbs.push({
            text: this.$t("venues"),
            to: "/venues",
          });
        }

        if (match.path == "/edit-venue") {
          breadcrumbs.push({
            text: this.$t("venues"),
            to: "/venues",
          });
        }

        if (
          match.path == "/list-room-forecast" ||
          match.path == "/list-trainer-productivity" ||
          match.path == "/create-room-forecast" ||
          match.path == "/edit-room-forecast" ||
          match.path == "/edit-trainer-productivity" ||
          match.path == "/list-target-revenue" ||
          match.path == "/create-target-revenue" ||
          match.path == "/edit-target-revenue"
        ) {
          breadcrumbs.push({
            text: this.$t("sales-list"),
            to: "/sales-list",
          });
        }
        if (
          match.path == "/list-room-forecast" ||
          match.path == "/list-trainer-productivity" ||
          match.path == "/create-room-forecast" ||
          match.path == "/edit-room-forecast" ||
          match.path == "/edit-trainer-productivity" ||
          match.path == "/list-target-revenue" ||
          match.path == "/create-target-revenue" ||
          match.path == "/edit-target-revenue"
        ) {
          breadcrumbs.push({
            text: this.$t("performance-board"),
            to: "/performance-board",
          });
        }

        if (
          match.path == "/create-target-revenue" ||
          match.path == "/edit-target-revenue"
        ) {
          breadcrumbs.push({
            text: this.$t("list-target-revenue"),
            to: "/list-target-revenue",
          });
        }

        if (match.path == "/edit-trainer-productivity") {
          breadcrumbs.push({
            text: this.$t("trainer-productivity"),
            to: "/list-trainer-productivity",
          });
        }

        if (match.path == "/create-room-forecast") {
          breadcrumbs.push({
            text: this.$t("room_forecast"),
            to: "/list-room-forecast",
          });
        }

        if (match.path == "/edit-room-forecast") {
          breadcrumbs.push({
            text: this.$t("room_forecast"),
            to: "/list-room-forecast",
          });
        }

        if (match.path == "/projects") {
          breadcrumbs.push({
            text: this.$t("sales-list"),
            to: "/sales-list",
          });
        }

        if (match.path == "/create-project") {
          breadcrumbs.push({
            text: this.$t("sales-list"),
            to: "/sales-list",
          });
        }

        if (match.path == "/edit-project") {
          breadcrumbs.push({
            text: this.$t("sales-list"),
            to: "/sales-list",
          });
        }

        if (match.path == "/create-project") {
          breadcrumbs.push({
            text: this.$t("projects"),
            to: "/projects",
          });
        }

        if (match.path == "/edit-project") {
          breadcrumbs.push({
            text: this.$t("projects"),
            to: "/projects",
          });
        }

        if (match.path == "/sales-request:pathMatch(.*)*") {
          breadcrumbs.push({
            text: this.$t("sales-list"),
            to: "/sales-list",
          });
        }

        if (this.breadcrumbParentName != null) {
          breadcrumbs.push({
            text: this.breadcrumbParentName,
            to: "/category?categoryId=" + this.breadcrumbParentLink,
          });
        }
        if (this.breadcrumbName) {
          breadcrumbs.push({
            text: this.breadcrumbName,
            to: null,
          });
        }
        if (this.traningName) {
          breadcrumbs.push({
            text: this.traningCategoryName,
            to: "/category?categoryId=" + this.traningCategoryLink,
          });
        }

        if (match.path == "/edit-training") {
          breadcrumbs.push({
            text: this.traningCategoryName,
            to: "/category?categoryId=" + this.traningCategoryLink,
          });
        }
        if (match.path == "/create-training") {
          breadcrumbs.push({
            text: this.traningCategoryName,
            to: "/category?categoryId=" + this.traningCategoryLink,
          });
        }

        if (match.path == "/request" && this.viewTrainingRequest) {
          breadcrumbs.push({
            text: this.$t("training_requests"),
            to: "/training-requests",
          });
        }

        if (this.traningName) {
          breadcrumbs.push({
            text: this.traningName,
            to: null,
          });
        }

        /* sales list and performance board*/

        if (match.path == "/performance-board") {
          breadcrumbs.push({
            text: this.$t("sales-list"),
            to: "/sales-list",
          });
        }

        /* if(match.path ==  "/list-trainer-productivity")
        { 
          breadcrumbs.push({
            text: this.$t('sales-list'),
            to: "/sales-list"
          });
        }*/

        if (match.path == "/tools/:pathMatch(.*)*") {
          breadcrumbs.push({
            text: this.$t("tools"),
          });
        }

        if (match.path == "/offers/:pathMatch(.*)*") {
          breadcrumbs.push({
            text: this.$t("offer"),
          });
        }

        if (match.path == "/venue") {
          breadcrumbs.push({
            text: this.$t("venue"),
            to: "/ourvenues",
          });
        }

        if (match.meta && match.meta.breadcrumb && !this.editName) {
          breadcrumbs.push({
            text: this.$t(match.meta.breadcrumb),
            // to: match.path !== route.path ? match.path : null
          });
        }

        if (this.editName) {
          breadcrumbs.push({
            text: this.$t(this.editName),
          });
        }

        if (this.trainingNameEdit) {
          breadcrumbs.push({
            text: this.trainingNameEdit,
          });
        }
      });

      // Add Home breadcrumb
      breadcrumbs.unshift({ text: this.$t("home"), to: "/" });

      return breadcrumbs;
    },
  },
};
</script>

<style scoped>
.breadcrumb-item.active {
  font-weight: bold;
}
</style>
